import { Anchor } from "@atlassiansox/bxp-content-framework";

import { useAnalytics, useAnalyticsAttributes } from "../../components";
import { UiLinkModel } from "../../models";

export type UiLinkProps = {
    readonly model: UiLinkModel;
};

const UiLink = ({
    model: {
        id,
        content: { entryTitle, text, ariaLabel, url }
    }
}: UiLinkProps) => {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (
        <Anchor
            href={url}
            aria-label={ariaLabel}
            onClick={() =>
                sendTrackEvent("clickedUiLink", {
                    eventContainer: "content",
                    ...analyticsAttributes,
                    event: "clicked",
                    eventComponent: "link",
                    label: text,
                    labelEnglish: entryTitle,
                    uuid: id,
                    href: url
                })
            }
            data-uuid={id}
        >
            {text}
        </Anchor>
    );
};

export default UiLink;
